import React, { ReactNode } from 'react';
import styled from 'styled-components';

import FooterMenuMobile from '#/components/layout/footer/FooterMenuMobile';
import BannerNotice from '#/components/layout/notice/BannerNoticeWrap';
import NotificationNoticeWrap from '#/components/layout/notice/NotificationNoticeWrap';

const WrapperMobile = styled.div`
  height: 100%;
  height: 100dvh;
  background: var(--mainDark);
  display: grid;
  grid-template-rows: max-content 1fr min-content max-content;
  grid-template-areas:
    'notification-notice'
    'exchange-body'
    'banner-notice'
    'bottom-menu';
  /* We cannot apply sides padding here,
  cause it would prevent scrollbar stick to sides */
  padding: 4px 0;
`;

const Body = styled.div`
  grid-area: exchange-body;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  max-width: 100vw;
  /* overflow: scroll; */
`;

const Wrapper = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
`;

// const ScrollWrapper = styled(Wrapper)`
//   overflow-y: auto;
//   ${scrollbarStyle}
// `;

function MainLayoutMobile({
  children,
  // scroll = false,
  footer = true,
}: {
  children: ReactNode;
  // scroll?: boolean;
  footer?: boolean;
}) {
  // const ContentWrap = scroll ? ScrollWrapper : Wrapper;
  // Add global .isMobileStyle class ("Style" postfix so we can easy search for)
  return (
    <WrapperMobile className="isMobileStyle">
      <NotificationNoticeWrap />

      <Body>
        <Wrapper>{children}</Wrapper>
      </Body>
      <BannerNotice />

      {footer && <FooterMenuMobile />}
    </WrapperMobile>
  );
}

export default MainLayoutMobile;
